/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable prettier/prettier */
import React, {useState} from 'react';
import {
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport
} from '@mui/x-data-grid';
import {esES} from '@mui/x-data-grid/locales';
import {Box, IconButton, TextField, Theme} from '@mui/material';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider, DatePicker} from '@mui/x-date-pickers';
import dayjs, {Dayjs} from 'dayjs';
import 'dayjs/locale/es';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

interface DataItem {
  [key: string]: any;
}

interface TableProps<T extends DataItem> {
  data: T[];
  columns: GridColDef[];
}

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.locale('es');
const DataGridComponent = <T extends DataItem>({
  data,
  columns
}: TableProps<T>) => {
  const [filteredData, setFilteredData] = useState<T[]>(data);
  const [filterText, setFilterText] = useState('');
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);

  const handleFilterText = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase().trim();
    setFilterText(value);
    filterData(value, startDate, endDate);
  };

  const handleStartDateChange = (date: Dayjs | null) => {
    setStartDate(date);
    filterData(filterText, date, endDate);
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    setEndDate(date);
    filterData(filterText, startDate, date);
  };
  const handleClearDates = () => {
    setStartDate(null);
    setEndDate(null);
    setFilterText('');
    filterData('', null, null);
  };
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
          }}
        >
          <Box sx={{mt: 3, mb: 2, display: 'flex', alignItems: 'center', gap: 2}}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: 'flex', gap: 3}}>
                <DatePicker
                  label="Fecha inicio"
                  value={startDate}
                  onChange={handleStartDateChange}
                  slotProps={{textField: {variant: 'outlined'}}}
                />
                <DatePicker
                  label="Fecha fin"
                  value={endDate}
                  onChange={handleEndDateChange}
                  slotProps={{textField: {variant: 'outlined'}}}
                />
              </Box>
            </LocalizationProvider>

            {/* TextField con un Box separado y gap */}
            <Box sx={{ml: 1}}>
              <TextField
                label="Filtrar por texto"
                value={filterText}
                onChange={handleFilterText}
                variant="outlined"
              />
            </Box>

            <IconButton edge="end" onClick={handleClearDates}>
              <RestartAltIcon />
            </IconButton>
          </Box>
        </div>
        <div>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport />
        </div>
      </GridToolbarContainer>
    );
  }
  const filterData = (text: string, start: Dayjs | null, end: Dayjs | null) => {
    const filteredItems = data.filter((item) => {
      const matchesText = Object.values(item).some(
        (val) => val && val.toString().toLowerCase().includes(text)
      );

      // Obtener la fecha del DataGrid
      const dateColumn =
        item.fechaContableFormatted || item.fechaRealFormatted || item.fecha;

      const itemDate = dateColumn
        ? dayjs(dateColumn, 'DD/MM/YYYY', true).isValid()
          ? dayjs(dateColumn, 'DD/MM/YYYY')
          : dayjs(dateColumn)
        : null;

      const dateMatches =
        (!start || (itemDate && itemDate.isSameOrAfter(start, 'day'))) &&
        (!end || (itemDate && itemDate.isSameOrBefore(end, 'day')));
      return matchesText && dateMatches;
    });

    setFilteredData(filteredItems);
  };

  const rows = filteredData.map((item, index) => ({id: index, ...item}));
  const sortedRows = [...rows].sort((a, b) => 
    dayjs(b.fechaFormatted, "DD/MM/YYYY").valueOf() - dayjs(a.fechaFormatted, "DD/MM/YYYY").valueOf()
  );

  return (
    <div>
      <br />
      <Box sx={{width: '100%', overflow: 'initial'}}>
        <DataGrid
          sx={{
            boxShadow: 2,
            border: 2,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main'
            }
          }}
          rows={sortedRows}
          editMode="row"
          autoHeight
          columns={columns.map((column) => ({
            ...column,
            headerClassName: 'custom-header',
            resizable: true
          }))}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100
              }
            },
            sorting: {
              sortModel: [{ field: "fechaFormatted", sort: "desc" }] 
            }
        
          }}
          slots={{
            toolbar: CustomToolbar
          }}
          pageSizeOptions={[25, 50, 100]}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        />
      </Box>
    </div>
  );
};

export default DataGridComponent;
